@if (initialized) {
  <mvs-widget
    *ngIf="myRecentCustomersWidget"
    [widgetData]="myRecentCustomersWidget"
    [disableUpdate]="true"
    (onObjectSelect)="handleObjectSelect($event)"
  ></mvs-widget>
}
